<div class="search-bar">
  <ion-icon class="search-icon" name="search-outline" slot=""></ion-icon>
  <input
    type="text"
    [placeholder]="placeholder"
    [value]="value"
    (input)="onInput($event)"
  />
  <button *ngIf="value" class="clear-btn" (click)="clear()">✕</button>
</div>
